<template lang="">
  <div>
    <van-form>
      <van-field
        v-model="formdate.name"
        input-align="right"
        readonly
        :label="!isUser ? '线索名称' : '客户名称'"
        maxlength="20"
        placeholder="-"
      />
      <van-field
        :value="formdate.source | enumMessage(AllEnums.CRM_CUSTOMER_SOURCE)"
        input-align="right"
        readonly
        label="客户来源"
        placeholder="-"
      />
      <van-field
        type="number"
        input-align="right"
        readonly
        v-model="formdate.mobile"
        label="手机号"
        maxlength="11"
        placeholder="-"
      />
      <van-field
        type="number"
        input-align="right"
        readonly
        v-model="formdate.telephone"
        label="电话"
        maxlength="11"
        placeholder="-"
      />
      <van-field
        :value="
          formdate.industryId | enumMessage(AllEnums.CRM_CUSTOMER_INDUSTRY)
        "
        input-align="right"
        readonly
        label="客户行业"
        placeholder="-"
      />
      <van-field
        :value="formdate.level | enumMessage(AllEnums.CRM_CUSTOMER_LEVEL)"
        input-align="right"
        readonly
        label="客户级别"
        placeholder="-"
      />
      <van-field
        v-model="formdate.areaName"
        input-align="right"
        readonly
        label="客户地址"
        placeholder="-"
      />
      <van-field
        v-model="formdate.detailAddress"
        input-align="right"
        rows="2"
        readonly
        type="textarea"
        autosize
        maxlength="100"
        label="详细地址"
        placeholder="-"
      />
      <van-field
        v-model="formdate.remark"
        input-align="right"
        readonly
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="250"
        placeholder="-"
      />
    </van-form>
  </div>
</template>
<script>
export default {
  props: {
    formdate: {
      type: Object,
      default: () => {},
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang=""></style>
